<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/electronics/changshu/cs.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    电子常熟工厂
                </div>
                <div class="manufacture-t2">
                    位于江苏省常熟市，以控制器+显示/音响端产品赋能智能座舱和智慧出行，为客户提供智能化系统集成解决方案。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                生产能力
            </div>
            <div class="page-t2">
                工厂具备电子SMT、焊接、装配、测试等工艺设计、开发能力
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                表面贴装(SMT)
                            </div>
                            <div class="destils">
                                低/中/高速贴装
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-1.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                表面贴装(SMT)
                            </div>
                            <div class="destils">

                                3D 锡膏印刷检查
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-2.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                表面贴装(SMT)
                            </div>
                            <div class="destils">

                                0201/BGA/连接头贴装
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                表面贴装(SMT)
                            </div>
                            <div class="destils">

                                自动光学检查

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-4.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                表面贴装(SMT)
                            </div>
                            <div class="destils">

                                激光刻码

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-5.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                表面贴装(SMT)
                            </div>
                            <div class="destils">

                                X-Ray检查
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs1-6.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                
            </div>
            <div class="page-t2">
                
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                电路板工艺
                            </div>
                            <div class="destils">
                                分板
                            </div>
                        </div>
                        
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                电路板工艺
                            </div>
                            <div class="destils">
                                
                                选择性焊接
                            </div>
                        </div>
                        
                    </div>
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                电路板工艺
                            </div>
                            <div class="destils">
                                三防漆喷涂

                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                
            </div>
            <div class="page-t2">
                
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                最终装配
                            </div>
                            <div class="destils">
                                点胶系统
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                电路板工艺
                            </div>
                            <div class="destils">

                                防错/视觉检查

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                最终装配
                            </div>
                            <div class="destils">
                                
                                自动螺丝紧固组装
                            

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                最终装配
                            </div>
                            <div class="destils">
                                
                                压接

                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs3-4.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                
            </div>
            <div class="page-t2">
                
            </div>
        </div>
        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                测试及工厂信息系统
                            </div>
                            <div class="destils">
                                在线测试(ICT)
                            </div>
                        </div>
                        
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                测试及工厂信息系统
                            </div>
                            <div class="destils">
                                
                                程序烧录
                            </div>
                        </div>
                        
                    </div>
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-4.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                测试及工厂信息系统
                            </div>
                            <div class="destils">
                                常温/高温测试

                            </div>
                        </div>
                        
                    </div>
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/changshu/cs4-5.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                测试及工厂信息系统
                            </div>
                            <div class="destils">
                                工厂信息系统(ERP/NMOM/SAP...)

                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '电子常熟工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/el/changshu.html'
};

import { createApp } from 'vue';
import App from './changshu.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./changshu.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
